import {Modal} from './Modal';
import ajax from '../utils/ajaxRequest';
import $ from 'jquery';
import {isMobile} from '../utils/mobileDetect';
import CookieHelper from "../helpers/CookieHelper";

const CONFIG = {
    listClass: 'ar-audience-selector__list',
    activeClass: 'ar-audience-selector__list__selected',
    countryListId: 'asCountryList',
    userTypeListId: 'asUserTypeList',
    submitId: 'asSubmit',
    submitEndpoint: '/api/setaudience',
    profilesEndpoint: '/api/audienceprofiles',
    cancelTop: 'asCancelTop',
    cancelBottom: 'asCancelBottom',
};

export class AudienceSelector extends Modal {

    constructor(userLoggedIn) {
        super({
            width: 1100,
            displayHeader: false,
            backdropClose: false,
            scrollLock: true,
            focusTrap: true,
        });

        this.userLoggedIn = !!userLoggedIn;
        this.activeCountry = undefined;
        this.activeUserType = undefined;
        this.$form = undefined;

        this.countryTplData = {};
        this.userTplData = {};

        this.template = _.template(document.querySelector('#asMainTpl').innerText);

        this.confirmationTpl = _.template(document.querySelector('#asConfirmationTpl').innerText);

        this.listTplDesktop = _.template(`
            <em class="ar-audience-selector__label"><%= label %></em>
            <ul class="ar-audience-selector__list">
                <% _.forEach(items, function(item, index) { %>
                    <li tabindex="0" data-item="<%- item.id || index %>" data-code="<%- item.code %>"><%- item.title %></li>
                <% }); %>
            </ul>
        `);

        this.listTplMobile = _.template(`
            <em class="ar-audience-selector__label"><%= label %></em>
            <div class="ar-audience-selector__select-wrap">
                <select class="ar-audience-selector__select">
                    <option value="" selected="selected">Please select</option>
                    <% _.forEach(items, function(item, index) { %>
                        <option value="<%- item.id || index %>"><%- item.title %></option>
                    <% }); %>
                </select>
            </div>
        `);
    }

    /**
    * Initialise this class
    */
   
    init() {
        super.init();
        ajax.get(CONFIG.profilesEndpoint).then((data) => {
            this.countryTplData = {'items': data.countries, 'label': 'I am based in ...'};
            this.userTplData = {'items': data.userTypes, 'label': 'I am a ...'};

            const countryList = (isMobile) ? this.listTplMobile(this.countryTplData) : this.listTplDesktop(this.countryTplData);
            this.template = this.template({'countryList': countryList});
            this.openSelector();

            this.$form = document.querySelector('form.ar-audience-selector');

            document.getElementById('targetUrl').setAttribute('value', location.pathname + location.search + location.hash);
            let userCountryType;
            let userInvestorType;
            // default option selection
            if (data.defaultUserData && data.defaultUserData.country && data.defaultUserData.investorType) {
                userCountryType = data.defaultUserData.country;
                userInvestorType = data.defaultUserData.investorType;
            } else { // In case no data from the server returned - use cookie.
                const cookieUserData = CookieHelper.getCookie();
                if(cookieUserData.artweb_country && cookieUserData.artweb_investorType) {
                    userCountryType = cookieUserData.artweb_country;
                    userInvestorType = cookieUserData.artweb_investorType;
                }
            }

            if(userCountryType && userInvestorType && data.userTypes && data.countries) {
                const countryIndex = this.findIndexByAttr(data.countries, 'code', userCountryType);
                const userIndex = this.findIndexByAttr(data.userTypes, 'code', userInvestorType);
                const userId = data.userTypes[userIndex].id;

                this.setActiveCountry(countryIndex, true);
                this.setActiveUserType(userId, true);
            }
            
            this.showConfirmation();
        })
    }
     
    /** 
     * Display the selector window (Modal)
     */
    openSelector() {
        this.setContent(this.template);
        this.show()
    }

    setActiveCountry(e, isInt) {
        if (!isInt &&  e.type && e.type === 'keypress' && e.which !== 13) {
            return;
        }
        const elementId = isInt ? e : e.target.getAttribute('data-item') || e.target.selectedOptions[0].value;
        this.activeCountry = this.countryTplData.items[+elementId];
        this.activeUserType = undefined;

        const userTypes = { 'items': this.permittedUserTypes(), 'label': 'I am a ...' }; 
        const userTypeMarkup = (isMobile) ? this.listTplMobile(userTypes) : this.listTplDesktop(userTypes);
        const newFormAction = (location.protocol + '//' + this.activeCountry.hostName + CONFIG.submitEndpoint);

        if(isMobile) {
            document.querySelector('#' + CONFIG.countryListId + ' select').value = elementId;
        } else {
            this.removeActiveState('#' + CONFIG.countryListId);
            var selectedElement = document.querySelector('#' + CONFIG.countryListId + ' li[data-item="' + elementId + '"]');
            selectedElement.classList.add(CONFIG.activeClass);
            selectedElement.setAttribute('aria-current', 'true');
        }

        this.$form.setAttribute('action', newFormAction);
 
        document.getElementById('country').setAttribute('value', this.activeCountry.code);
        var userTypeElement = document.getElementById(CONFIG.userTypeListId)
        userTypeElement.innerHTML = userTypeMarkup;
        if(!isInt && e.type && e.type === "keypress" ){
            userTypeElement.querySelector('[tabindex="0"]').focus();
        }
        document.getElementById('asConfirmation').innerHTML = '';
    }

    setActiveUserType(e, isId) {
        if (!isId && e.type && e.type === 'keypress' && e.which !== 13) {
            return;
        }

        const elementId = isId ? e : e.target.getAttribute('data-item') || e.target.selectedOptions[0].value;
        this.activeUserType = this.userTplData.items.filter((val) => { return val.id === parseInt(elementId)})[0];

        if(isMobile) {
            document.querySelector('#' + CONFIG.userTypeListId + ' select').value = elementId;
        } else {
            this.removeActiveState('#' + CONFIG.userTypeListId);
            var selectedElement = document.querySelector('#' + CONFIG.userTypeListId + ' li[data-item="' + elementId + '"]');
            selectedElement.classList.add(CONFIG.activeClass);
            selectedElement.setAttribute('aria-current', 'true');
        }

        document.getElementById('investorType').setAttribute('value', this.activeUserType.code);

        this.showConfirmation();
        if(!isId && e.type === "keypress" ){
            document.getElementById(CONFIG.submitId).focus();
        }
    }

    /**
     * Unset activeItem property and remove active class
     * @private
     */
    removeActiveState(parent) {
        const activeElements = document.querySelector(parent + ' .' + CONFIG.activeClass);

        if(activeElements) {
            activeElements.classList.remove(CONFIG.activeClass);
            activeElements.removeAttribute('aria-current');
        }
    }

    /**
     * Display the confirmation content
     * @private
     */
    showConfirmation() {
        if (!this.activeUserType || !this.activeCountry) return;
        const confirmationTplData = {
            'usertype': this.activeUserType.title,
            'userId' : this.activeUserType.id,
            'country': this.activeCountry.title,
            'showdisclaimer': this.activeUserType.code.toLowerCase() === 'pvi',
            'audienceSelectorDefinition': this.activeCountry.userTypeDefinitions
        };

        document.getElementById('asConfirmation').innerHTML = this.confirmationTpl(confirmationTplData);
    }

    /**
     * Generate user types array depending on selected country - progressive selection
     * @private
     */
    permittedUserTypes() {
        return this.userTplData.items.filter((val) => this.activeCountry.userTypes.indexOf(val.id) > -1);
    }

    findIndexByAttr(arr, atr, val) {
        for(var i = 0; i < arr.length; i++) {
            if(arr[i][atr] === val) {
                return i;
            }
        }
        return -1;
    }

    initEventListeners() {
        super.initEventListeners();

        if (isMobile) {
            $('body')
                .on('change', '#' + CONFIG.countryListId + ' select', this.setActiveCountry.bind(this))
                .on('change', '#' + CONFIG.userTypeListId + ' select', this.setActiveUserType.bind(this));
        }

        if (!isMobile) {
            $('body')
            .on('click keypress', '#' + CONFIG.countryListId + ' li', this.setActiveCountry.bind(this))
            .on('click keypress', '#' + CONFIG.userTypeListId + ' li', this.setActiveUserType.bind(this));
        }
    }

    // Override method to block `Modal` event listeners. User can only close window on specific interactions.
    initCloseEventListeners() {
        if (!this.userLoggedIn) return;

        var closeWindow = function() {
            let url = window.location.href;
            if (url.endsWith("#")) {
                url = url.slice(0, -1);
            }
            window.location.assign(url);
        };

        $(document)
            .on('click', '#' + CONFIG.cancelTop, closeWindow)
            .on('click', '#' + CONFIG.cancelBottom, closeWindow)
            .on('keyup', (e) => {
                if (e.key === 'Escape') closeWindow();
            });
    }
}

var instance;

export var show = () => instance || (instance = new AudienceSelector(window.userLoggedIn).init());